import ELKCourseAPI from '@/apis/business/MISAStore/elk-course-api.js'

export default {

  namespaced: true,

  state: {
    listELKCourses: [], // Danh sách học liệu của I Giáo dục
    totalExerciseELK: 0, // Số lượng học liệu của I Giáo dục
    listSourceCourseOverviews: [], // Danh sách học liệu củng cố kiến thức và luyện tập
    listSubjectCourseOverviews: [] // Danh sách học liệu theo môn
  },

  getters: {},

  mutations: {
    /**
     * set Count Course
     * CreateBy: VHSON 24.09
     */
    setTotalCount (state, totalExerciseELK) {
      state.totalExerciseELK = totalExerciseELK
    },

    /**
     * set list Course
     * CreateBy: VHSON 24.09
     */

    setHanhTrangSoCourse (state, listELKCourses) {
      state.listELKCourses = listELKCourses
    },

    /**
     * set list Course ôn luyện và luyện tập
     * CreateBy: VHSON 23.12
     */

    setlistSourceCourseOverviews (state, listSourceCourseOverviews) {
      state.listSourceCourseOverviews = listSourceCourseOverviews
    },

    /**
     * set list Course cho màn tổng quan
     * CreateBy: VHSON 23.12
     */

    setlistSubjectCourseOverviews (state, listSubjectCourseOverviews) {
      state.listSubjectCourseOverviews = listSubjectCourseOverviews
    }
  },

  actions: {
    /**
     * Lấy danh sách học liệu của tất cả các nguồn
     * @author VHSon
     * @param {*} textSearch
     * @param {*} gradeID
     * @param {*} subjectID
     * @param {*} sourceType
     * @returns
     */
    getlistELKCourse (context, courseParams) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync(
        `/list-total-elk?queryText=${courseParams.textSearch}` +
          `&gradeID=${courseParams.gradeID}` +
          `&subjectID=${courseParams.subjectID}` +
          `&takeCharge=${courseParams.takeCharge}` +
          `&sourceType=${courseParams.sourceType}` +
          `&pageIndex=${courseParams.pageIndex}` +
          `&pageSize=${courseParams.pageSize}`
        )
          .then((res) => {
            context.commit('setHanhTrangSoCourse', res?.Data)
            context.commit('setTotalCount', res.Data?.Total)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu củng cố kiến thức và luyện tập
     * @author VHSon
     * @param {*} gradeID
     * @returns
     */
    getlistSourceCourseForOverview (context, gradeID) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync(`/list-course-source?gradeID=${gradeID}`)
          .then((res) => {
            context.commit('setlistSourceCourseOverviews', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },

    /**
     * Lấy danh sách học liệu  nguồn
     * @author VHSon
     * @param {*} gradeID
     * @returns
     */
    getlistSubjectCourseForOverview (context, gradeID) {
      return new Promise((resolve, reject) => {
        ELKCourseAPI.getAsync(`/list-course-subject?gradeID=${gradeID}`)
          .then((res) => {
            context.commit('setlistSubjectCourseOverviews', res?.Data)
            resolve(res.Data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    }
  }
}
